/**
 * Cómo se escriben los números en el Pricer Datec: el estilo del documento de Datec (en-US), el mismo que ve el
 * cliente en el PDF: `1,312.15`, `USD 13,546.96`, `31.2 %`. Sólo cambia cómo se ESCRIBE un número ya calculado;
 * ningún importe guardado ni calculado se toca. (El módulo Estrategias sigue con es-BO: es otro formato a propósito.)
 */
import { formatoPorcentaje, formatoPrecioEn } from '@/lib/utils/formato-precio';

type OpcionesPct = Parameters<typeof formatoPorcentaje>[1];

/** 20.73 → «20.7 %»; con `decimales: 2`, «20.73 %». */
export const pctDatec = (n: number, o: OpcionesPct = {}): string =>
  formatoPorcentaje(n, { ...o, local: 'en-US' });

/** 14121.511 → «14,121.51». Siempre dos decimales. */
export const numeroDatec = (n: number): string => formatoPrecioEn(n, 'en-US');

/** 14121.511 → «USD 14,121.51». */
export const usdDatec = (n: number): string => `USD ${numeroDatec(n)}`;
